const module = {
  config: {
    name: 'gallery-folders-module',
    icon: 'ri-user-line',
    desc: '',
    group: 'Forum',
    layout: true
  },
  routes: [
    { name: 'gallery-folders', label: 'Galeri', icon: 'ri-image-2-fill', path: '/gallery-folders', component: () => import('./gallery-folders.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/gallery-folders/_index.js